import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardFooter } from './ui/card';
import { ShoppingCart, Sparkles, Tag } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const ProductCard = ({ product, onAddToCart, isAdmin }) => {
  const isQuoteOnly = product.is_quote_only;
  const hasOldPrice = product.is_sale && product.old_price && product.old_price > product.price;
  const discountPct = hasOldPrice ? Math.round(((product.old_price - product.price) / product.old_price) * 100) : 0;

  return (
    <Card
      className="overflow-hidden hover:-translate-y-1 hover:shadow-md transition-all duration-200 border border-slate-200"
      data-testid={`product-card-${product.id}`}
    >
      <div className="h-48 bg-slate-200 overflow-hidden relative">
        {product.image_path ? (
          <img
            src={`${API_BASE}/api/files/${product.image_path}`}
            alt={product.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-400">
            <span style={{ fontFamily: 'IBM Plex Sans' }}>Fără imagine</span>
          </div>
        )}
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {product.is_new && (
            <span
              className="inline-flex items-center gap-1 bg-green-600 text-white text-xs font-bold px-2 py-1 rounded-md shadow-md"
              style={{ fontFamily: 'IBM Plex Sans' }}
              data-testid={`badge-new-${product.id}`}
            >
              <Sparkles className="w-3 h-3" /> NOU
            </span>
          )}
          {product.is_sale && !isQuoteOnly && (
            <span
              className="inline-flex items-center gap-1 bg-orange-600 text-white text-xs font-bold px-2 py-1 rounded-md shadow-md"
              style={{ fontFamily: 'IBM Plex Sans' }}
              data-testid={`badge-sale-${product.id}`}
            >
              <Tag className="w-3 h-3" /> {discountPct > 0 ? `-${discountPct}%` : 'REDUS'}
            </span>
          )}
        </div>
      </div>

      <CardContent className="p-5">
        <h3
          className="text-lg font-bold text-slate-900 mb-2"
          style={{ fontFamily: 'Outfit' }}
          data-testid={`product-name-${product.id}`}
        >
          {product.name}
        </h3>
        <p
          className="text-sm text-slate-600 mb-3 line-clamp-2"
          style={{ fontFamily: 'IBM Plex Sans' }}
        >
          {product.description}
        </p>
        {isQuoteOnly ? (
          <p
            className="text-xl font-bold text-orange-600"
            style={{ fontFamily: 'Outfit' }}
            data-testid={`product-quote-${product.id}`}
          >
            Cere ofertă
          </p>
        ) : (
          <div className="flex items-baseline gap-2">
            <p
              className="text-2xl font-bold text-blue-900"
              style={{ fontFamily: 'Outfit' }}
              data-testid={`product-price-${product.id}`}
            >
              {product.price} RON
            </p>
            {hasOldPrice && (
              <p
                className="text-sm text-slate-400 line-through"
                style={{ fontFamily: 'IBM Plex Sans' }}
                data-testid={`product-old-price-${product.id}`}
              >
                {product.old_price} RON
              </p>
            )}
          </div>
        )}
      </CardContent>

      {!isAdmin && (
        <CardFooter className="p-5 pt-0">
          <Button
            onClick={() => onAddToCart(product)}
            className="w-full bg-orange-600 hover:bg-orange-700 text-white transition-colors"
            data-testid={`add-to-cart-${product.id}`}
            style={{ fontFamily: 'IBM Plex Sans' }}
          >
            <ShoppingCart className="w-4 h-4 mr-2" />
            Adaugă în coș
          </Button>
        </CardFooter>
      )}
    </Card>
  );
};

export default ProductCard;
